import * as types from '../actions/types';

const initialState = {
    years: [],
    meth_plan_1: null,
    meth_plan_2: null,
    meth_plan_3: null,
    meth_plan_4: null,
    loading: false,
};

export default function methodPlan(state = initialState, action) {
    switch (action.type) {
        case types.METHOD_PLAN_YEARS:
            return {
                ...state,
                years: action.payload
            };
        case types.METHPLAN_1:
            return {
                ...state,
                meth_plan_1: action.payload
            };
        case types.METHPLAN_2:
            return {
                ...state,
                meth_plan_2: action.payload
            };
        case types.METHPLAN_3:
            return {
                ...state,
                meth_plan_3: action.payload
            };
        case types.METHPLAN_4:
            return {
                ...state,
                meth_plan_4: action.payload
            };
        case types.SET_METHPLAN_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        default:
            return state;
    }
}
